// import React, { useState, FormEvent, useContext } from 'react';
// import { CreateCourseRequest } from '../types/course';
// import { AuthContext } from '../context/AuthContext';
// import DriveFolderSelector from './DriveFolderSelector';
// import '../styles/CourseForm.css';

// // --- DurationInput Component (months + days only) ---
// interface DurationInputProps {
//     label: string;
//     value: { months: number; days: number };
//     onChange: (value: { months: number; days: number }) => void;
//     namePrefix?: string;
// }
// function DurationInput({
//                            label,
//                            value,
//                            onChange,
//                            namePrefix = '',
//                        }: DurationInputProps) {
//     return (
//         <div className="duration-input-group">
//             <label className="course-form-label">{label}</label>
//             <div className="duration-input-row">
//                 <input
//                     type="number"
//                     min="0"
//                     max="11"
//                     value={value.months}
//                     onChange={e =>
//                         onChange({ ...value, months: parseInt(e.target.value, 10) })
//                     }
//                     className="duration-input duration-months"
//                     name={`${namePrefix}Months`}
//                     aria-label="Months"
//                     placeholder="M"
//                     style={{ width: 48, marginRight: 4 }}
//                 />
//                 <span style={{ marginRight: 8 }}>m</span>
//                 <input
//                     type="number"
//                     min="0"
//                     max="30"
//                     value={value.days}
//                     onChange={e =>
//                         onChange({ ...value, days: parseInt(e.target.value, 10) })
//                     }
//                     className="duration-input duration-days"
//                     name={`${namePrefix}Days`}
//                     aria-label="Days"
//                     placeholder="D"
//                     style={{ width: 48 }}
//                 />
//                 <span>d</span>
//             </div>
//         </div>
//     );
// }

// // --- Main CourseForm ---
// interface Props {
//     onSubmit: (data: CreateCourseRequest) => Promise<void>;
//     onCancel: () => void;
// }

// export default function CourseForm({ onSubmit, onCancel }: Props) {
//     const { user } = useContext(AuthContext);
//     const isSuperadmin = user?.role === 'superadmin';

//     const [form, setForm] = useState({
//         name: '',
//         description: '',
//         baseFee: '',
//         telegramServerId: '',
//         maxViewerDiscount: '',
//         period: { months: 0, days: 0 },
//         materialAccessPeriod: { months: 0, days: 0 },
//         driveFolderId: '',
//     });
//     const [error, setError] = useState<string>('');
//     const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

//     const handleChange = (
//         e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
//     ) => {
//         const { name, value } = e.target;
//         setForm(prev => ({
//             ...prev,
//             [name]:
//                 name === 'baseFee' || name === 'maxViewerDiscount'
//                     ? value.replace(/[^0-9]/g, '')
//                     : value,
//         }));
//     };

//     const handleDurationChange = (
//         field: 'period' | 'materialAccessPeriod',
//         value: { months: number; days: number }
//     ) => {
//         setForm(prev => ({
//             ...prev,
//             [field]: value,
//         }));
//     };

//     const handleFolderSelect = (folderId: string, folderName: string) => {
//         setForm(prev => ({
//             ...prev,
//             driveFolderId: folderId,
//         }));
//     };

//     // Converts duration into total days (1 month = 30 days)
//     const durationToDays = (d: { months: number; days: number }) =>
//         d.months * 30 + d.days;

//     const handleSubmit = async (e: FormEvent) => {
//         e.preventDefault();
//         setError('');
//         setIsSubmitting(true);
//         try {
//             const payload: CreateCourseRequest = {
//                 name: form.name.trim(),
//                 description: form.description.trim(),
//                 baseFee: Number(form.baseFee) || 0,
//                 telegramServerId: form.telegramServerId.trim(),
//                 // still using field name "...Months", but now carries days
//                 periodMonths: durationToDays(form.period),
//                 maxViewerDiscount: 0,
//                 materialAccessPeriod: 0,
//                 driveFolderId: form.driveFolderId.trim(),
//             };

//             if (isSuperadmin) {
//                 payload.maxViewerDiscount = Number(form.maxViewerDiscount) || 0;
//                 payload.materialAccessPeriod = durationToDays(
//                     form.materialAccessPeriod
//                 );
//             } else {
//                 delete (payload as any).maxViewerDiscount;
//                 delete (payload as any).materialAccessPeriod;
//             }

//             await onSubmit(payload);
//         } catch (err: any) {
//             setError(err.response?.data?.message || err.message);
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     return (
//         <div className="course-form-overlay">
//             {isSubmitting && (
//                 <div className="course-form-loading-overlay">
//                     <div className="course-form-loading-spinner">
//                         <div className="spinner"></div>
//                         <p>Creating course with drive access...</p>
//                     </div>
//                 </div>
//             )}
//             <div className="course-form-container">
//                 <div className="course-form-header">
//                     <h1 className="course-form-title">Create Course</h1>
//                 </div>
//                 {error && <div className="course-form-error">{error}</div>}

//                 <form className="course-form-grid" onSubmit={handleSubmit}>
//                     {/* Name */}
//                     <div className="course-form-group" style={{ gridColumn: '1/-1' }}>
//                         <label className="course-form-label" htmlFor="name">
//                             Name
//                         </label>
//                         <input
//                             id="name"
//                             name="name"
//                             type="text"
//                             className="course-form-input"
//                             value={form.name}
//                             onChange={handleChange}
//                             required
//                             placeholder="Course name"
//                         />
//                     </div>

//                     {/* Description */}
//                     <div className="course-form-group" style={{ gridColumn: '1/-1' }}>
//                         <label className="course-form-label" htmlFor="description">
//                             Description
//                         </label>
//                         <textarea
//                             id="description"
//                             name="description"
//                             className="course-form-input"
//                             value={form.description}
//                             onChange={handleChange}
//                             placeholder="Short course description"
//                             rows={3}
//                         />
//                     </div>

//                     {/* Base Fee */}
//                     <div className="course-form-group">
//                         <label className="course-form-label" htmlFor="baseFee">
//                             Base Fee
//                         </label>
//                         <input
//                             id="baseFee"
//                             name="baseFee"
//                             type="text"
//                             inputMode="numeric"
//                             pattern="[0-9]*"
//                             className="course-form-input no-spinner"
//                             value={form.baseFee}
//                             onChange={handleChange}
//                             required
//                             placeholder="e.g. 5000"
//                             autoComplete="off"
//                         />
//                     </div>

//                     {isSuperadmin ? (
//                         <>
//                             {/* Max Viewer Discount */}
//                             <div className="course-form-group">
//                                 <label
//                                     className="course-form-label"
//                                     htmlFor="maxViewerDiscount"
//                                 >
//                                     Max Viewer Discount
//                                 </label>
//                                 <input
//                                     id="maxViewerDiscount"
//                                     name="maxViewerDiscount"
//                                     type="text"
//                                     inputMode="numeric"
//                                     pattern="[0-9]*"
//                                     min="0"
//                                     className="course-form-input no-spinner"
//                                     value={form.maxViewerDiscount}
//                                     onChange={handleChange}
//                                     required
//                                     placeholder="e.g. 20"
//                                     autoComplete="off"
//                                 />
//                             </div>

//                             {/* Material Access Period */}
//                             <div className="course-form-group">
//                                 <DurationInput
//                                     label="Material Access Period"
//                                     value={form.materialAccessPeriod}
//                                     onChange={v =>
//                                         handleDurationChange('materialAccessPeriod', v)
//                                     }
//                                     namePrefix="materialAccessPeriod"
//                                 />
//                             </div>

//                             {/* Period */}
//                             <div className="course-form-group">
//                                 <DurationInput
//                                     label="Period"
//                                     value={form.period}
//                                     onChange={v => handleDurationChange('period', v)}
//                                     namePrefix="period"
//                                 />
//                             </div>

//                             {/* Telegram Server ID */}
//                             <div className="course-form-group">
//                                 <label
//                                     className="course-form-label"
//                                     htmlFor="telegramServerId"
//                                 >
//                                     Telegram Server ID
//                                 </label>
//                                 <input
//                                     id="telegramServerId"
//                                     name="telegramServerId"
//                                     type="text"
//                                     className="course-form-input"
//                                     value={form.telegramServerId}
//                                     onChange={handleChange}
//                                     placeholder="Optional"
//                                 />
//                             </div>

//                             {/* Google Drive Folder */}
//                             <div className="course-form-group" style={{ gridColumn: '1/-1' }}>
//                                 <DriveFolderSelector
//                                     selectedFolderId={form.driveFolderId}
//                                     onFolderSelect={handleFolderSelect}
//                                 />
//                             </div>
//                         </>
//                     ) : (
//                         <>
//                             {/* Telegram Server ID */}
//                             <div className="course-form-group" style={{ gridColumn: '1/-1' }}>
//                                 <label
//                                     className="course-form-label"
//                                     htmlFor="telegramServerId"
//                                 >
//                                     Telegram Server ID
//                                 </label>
//                                 <input
//                                     id="telegramServerId"
//                                     name="telegramServerId"
//                                     type="text"
//                                     className="course-form-input"
//                                     value={form.telegramServerId}
//                                     onChange={handleChange}
//                                     placeholder="Optional"
//                                 />
//                             </div>

//                             {/* Period */}
//                             <div className="course-form-group" style={{ gridColumn: '1/-1' }}>
//                                 <DurationInput
//                                     label="Period"
//                                     value={form.period}
//                                     onChange={v => handleDurationChange('period', v)}
//                                     namePrefix="period"
//                                 />
//                             </div>

//                             {/* Google Drive Folder */}
//                             <div className="course-form-group" style={{ gridColumn: '1/-1' }}>
//                                 <DriveFolderSelector
//                                     selectedFolderId={form.driveFolderId}
//                                     onFolderSelect={handleFolderSelect}
//                                 />
//                             </div>
//                         </>
//                     )}

//                     {/* Buttons */}
//                     <div className="course-button-group" style={{ gridColumn: '1/-1' }}>
//                         <button
//                             type="button"
//                             className="course-btn course-btn-cancel"
//                             onClick={onCancel}
//                             disabled={isSubmitting}
//                         >
//                             Cancel
//                         </button>
//                         <button
//                             type="submit"
//                             className="course-btn course-btn-save"
//                             disabled={isSubmitting}
//                         >
//                             {isSubmitting ? 'Creating...' : 'Create'}
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// }

// src/components/CourseForm.tsx

import React, { FormEvent, useContext, useState } from "react";
import { ContentDeliveryMode, CreateCourseRequest } from "../types/course";
import { AuthContext } from "../context/AuthContext";
import { encodeMaterialDuration, isDevelopmentTimer } from "../utils/timerMode";
import DriveFolderSelector from "./DriveFolderSelector";

/* =========================================================
   SHARED STYLES
========================================================= */

const labelClass = "mb-1.5 block text-[13px] font-semibold text-slate-700";

const inputClass =
  "box-border h-10 w-full rounded-[9px] border border-slate-200 bg-white " +
  "px-3 text-[13px] text-slate-900 outline-none transition " +
  "placeholder:text-slate-400 hover:border-slate-300 " +
  "focus:border-slate-400 focus:ring-2 focus:ring-slate-100";

const textareaClass =
  "box-border min-h-[84px] w-full resize-y rounded-[9px] border " +
  "border-slate-200 bg-white px-3 py-2.5 text-[13px] leading-5 " +
  "text-slate-900 outline-none transition placeholder:text-slate-400 " +
  "hover:border-slate-300 focus:border-slate-400 focus:ring-2 " +
  "focus:ring-slate-100";

const numberInputClass =
  "h-full min-w-0 flex-1 border-0 bg-transparent p-0 text-[13px] " +
  "font-semibold text-slate-900 outline-none appearance-none " +
  "[&::-webkit-inner-spin-button]:appearance-none " +
  "[&::-webkit-outer-spin-button]:appearance-none";

/*
 * DriveFolderSelector still contains legacy class names internally.
 *
 * These Tailwind descendant selectors style that child component so
 * CourseForm.css is no longer required by this form.
 */
const driveSelectorStyles = `
    [&_.course-form-label]:mb-1.5
    [&_.course-form-label]:block
    [&_.course-form-label]:text-[13px]
    [&_.course-form-label]:font-semibold
    [&_.course-form-label]:text-slate-700

    [&_.drive-folder-selector]:flex
    [&_.drive-folder-selector]:flex-col
    [&_.drive-folder-selector]:gap-2

    [&_.drive-selected-banner]:flex
    [&_.drive-selected-banner]:items-center
    [&_.drive-selected-banner]:justify-between
    [&_.drive-selected-banner]:gap-3
    [&_.drive-selected-banner]:rounded-lg
    [&_.drive-selected-banner]:border
    [&_.drive-selected-banner]:border-emerald-200
    [&_.drive-selected-banner]:bg-emerald-50
    [&_.drive-selected-banner]:px-3
    [&_.drive-selected-banner]:py-2
    [&_.drive-selected-banner]:text-[12px]
    [&_.drive-selected-banner]:text-emerald-800

    [&_.drive-clear-btn]:shrink-0
    [&_.drive-clear-btn]:rounded-md
    [&_.drive-clear-btn]:border-0
    [&_.drive-clear-btn]:bg-transparent
    [&_.drive-clear-btn]:px-2
    [&_.drive-clear-btn]:py-1
    [&_.drive-clear-btn]:text-[11px]
    [&_.drive-clear-btn]:font-medium
    [&_.drive-clear-btn]:text-slate-500
    [&_.drive-clear-btn]:transition
    [&_.drive-clear-btn:hover]:bg-white
    [&_.drive-clear-btn:hover]:text-slate-800

    [&_.drive-tabs]:flex
    [&_.drive-tabs]:flex-wrap
    [&_.drive-tabs]:gap-1
    [&_.drive-tabs]:border-b
    [&_.drive-tabs]:border-slate-200

    [&_.drive-tab]:border-0
    [&_.drive-tab]:border-b-2
    [&_.drive-tab]:border-transparent
    [&_.drive-tab]:bg-transparent
    [&_.drive-tab]:px-2.5
    [&_.drive-tab]:py-1.5
    [&_.drive-tab]:text-[12px]
    [&_.drive-tab]:font-medium
    [&_.drive-tab]:text-slate-500
    [&_.drive-tab]:transition
    [&_.drive-tab:hover]:text-slate-900

    [&_.drive-tab-active]:border-slate-900
    [&_.drive-tab-active]:font-semibold
    [&_.drive-tab-active]:text-slate-900

    [&_.drive-breadcrumb]:flex
    [&_.drive-breadcrumb]:min-h-[22px]
    [&_.drive-breadcrumb]:flex-wrap
    [&_.drive-breadcrumb]:items-center
    [&_.drive-breadcrumb]:gap-1
    [&_.drive-breadcrumb]:text-[11px]
    [&_.drive-breadcrumb]:text-slate-500

    [&_.drive-breadcrumb-item]:rounded
    [&_.drive-breadcrumb-item]:border-0
    [&_.drive-breadcrumb-item]:bg-transparent
    [&_.drive-breadcrumb-item]:px-1
    [&_.drive-breadcrumb-item]:py-0.5
    [&_.drive-breadcrumb-item]:text-[11px]
    [&_.drive-breadcrumb-item]:text-slate-700
    [&_.drive-breadcrumb-item]:underline
    [&_.drive-breadcrumb-item]:underline-offset-2

    [&_.drive-breadcrumb-sep]:text-slate-300

    [&_.drive-folder-list]:max-h-[170px]
    [&_.drive-folder-list]:overflow-y-auto
    [&_.drive-folder-list]:rounded-[9px]
    [&_.drive-folder-list]:border
    [&_.drive-folder-list]:border-slate-200
    [&_.drive-folder-list]:bg-white

    [&_.drive-folder-loading]:px-4
    [&_.drive-folder-loading]:py-6
    [&_.drive-folder-loading]:text-center
    [&_.drive-folder-loading]:text-[12px]
    [&_.drive-folder-loading]:text-slate-500

    [&_.drive-folder-empty]:px-4
    [&_.drive-folder-empty]:py-6
    [&_.drive-folder-empty]:text-center
    [&_.drive-folder-empty]:text-[12px]
    [&_.drive-folder-empty]:text-slate-500

    [&_.drive-folder-error]:px-4
    [&_.drive-folder-error]:py-4
    [&_.drive-folder-error]:text-center
    [&_.drive-folder-error]:text-[12px]
    [&_.drive-folder-error]:text-red-600

    [&_.drive-folder-row]:flex
    [&_.drive-folder-row]:min-h-[38px]
    [&_.drive-folder-row]:items-center
    [&_.drive-folder-row]:justify-between
    [&_.drive-folder-row]:gap-2
    [&_.drive-folder-row]:border-b
    [&_.drive-folder-row]:border-slate-100
    [&_.drive-folder-row]:px-3
    [&_.drive-folder-row]:py-1.5
    [&_.drive-folder-row]:transition
    [&_.drive-folder-row:last-child]:border-b-0
    [&_.drive-folder-row:hover]:bg-slate-50

    [&_.drive-folder-row-selected]:bg-emerald-50
    [&_.drive-folder-row-selected:hover]:bg-emerald-50

    [&_.drive-folder-name-btn]:flex
    [&_.drive-folder-name-btn]:min-w-0
    [&_.drive-folder-name-btn]:flex-1
    [&_.drive-folder-name-btn]:items-center
    [&_.drive-folder-name-btn]:gap-2
    [&_.drive-folder-name-btn]:overflow-hidden
    [&_.drive-folder-name-btn]:border-0
    [&_.drive-folder-name-btn]:bg-transparent
    [&_.drive-folder-name-btn]:p-0
    [&_.drive-folder-name-btn]:text-left
    [&_.drive-folder-name-btn]:text-[12px]
    [&_.drive-folder-name-btn]:font-medium
    [&_.drive-folder-name-btn]:text-slate-700
    [&_.drive-folder-name-btn]:whitespace-nowrap
    [&_.drive-folder-name-btn]:text-ellipsis

    [&_.drive-folder-icon]:shrink-0

    [&_.drive-select-btn]:shrink-0
    [&_.drive-select-btn]:rounded-md
    [&_.drive-select-btn]:border
    [&_.drive-select-btn]:border-slate-200
    [&_.drive-select-btn]:bg-white
    [&_.drive-select-btn]:px-2.5
    [&_.drive-select-btn]:py-1
    [&_.drive-select-btn]:text-[11px]
    [&_.drive-select-btn]:font-medium
    [&_.drive-select-btn]:text-slate-600
    [&_.drive-select-btn]:transition
    [&_.drive-select-btn:hover]:bg-slate-100

    [&_.drive-select-btn-active]:border-emerald-700
    [&_.drive-select-btn-active]:bg-emerald-700
    [&_.drive-select-btn-active]:text-white
    [&_.drive-select-btn-active:hover]:bg-emerald-800
`;

/* =========================================================
   ICONS
========================================================= */

const CloseIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M6 6l12 12M18 6 6 18"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

const CourseIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M5 4.5A2.5 2.5 0 0 1 7.5 2H19v17H7.5A2.5 2.5 0 0 0 5 21.5v-17Z"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
    <path d="M5 19V4.5" stroke="currentColor" strokeWidth="1.7" />
  </svg>
);

const Spinner = () => (
  <span
    className="
            inline-block h-5 w-5 animate-spin rounded-full
            border-2 border-slate-200 border-t-slate-900
        "
    aria-hidden="true"
  />
);

/* =========================================================
   DURATION
========================================================= */

interface DurationInputProps {
  label: string;
  value: {
    months: number;
    days: number;
  };
  onChange: (value: { months: number; days: number }) => void;
  namePrefix?: string;
}

function DurationInput({
  label,
  value,
  onChange,
  namePrefix = "",
}: DurationInputProps) {
  const useDevelopmentUnits =
    namePrefix === "materialAccessPeriod" && isDevelopmentTimer;
  return (
    <div>
      <label className={labelClass}>{label}</label>

      <div className="grid grid-cols-2 gap-2">
        <div
          className="
                        flex h-10 items-center rounded-[9px]
                        border border-slate-200 bg-white px-3
                        transition
                        focus-within:border-slate-400
                        focus-within:ring-2 focus-within:ring-slate-100
                    "
        >
          <input
            type="number"
            min={0}
            max={11}
            value={value.months}
            onChange={(e) =>
              onChange({
                ...value,
                months: parseInt(e.target.value, 10) || 0,
              })
            }
            className={numberInputClass}
            name={`${namePrefix}Months`}
            aria-label={`${label} ${useDevelopmentUnits ? "hours" : "months"}`}
          />

          <span className="ml-2 shrink-0 text-[11px] font-medium text-slate-400">
            {useDevelopmentUnits ? "hours" : "months"}
          </span>
        </div>

        <div
          className="
                        flex h-10 items-center rounded-[9px]
                        border border-slate-200 bg-white px-3
                        transition
                        focus-within:border-slate-400
                        focus-within:ring-2 focus-within:ring-slate-100
                    "
        >
          <input
            type="number"
            min={0}
            max={useDevelopmentUnits ? 59 : 30}
            value={value.days}
            onChange={(e) =>
              onChange({
                ...value,
                days: parseInt(e.target.value, 10) || 0,
              })
            }
            className={numberInputClass}
            name={`${namePrefix}Days`}
            aria-label={`${label} ${useDevelopmentUnits ? "minutes" : "days"}`}
          />

          <span className="ml-2 shrink-0 text-[11px] font-medium text-slate-400">
            {useDevelopmentUnits ? "minutes" : "days"}
          </span>
        </div>
      </div>
    </div>
  );
}

/* =========================================================
   COMPONENT
========================================================= */

interface Props {
  onSubmit: (data: CreateCourseRequest) => Promise<void>;

  onCancel: () => void;
}

export default function CourseForm({ onSubmit, onCancel }: Props) {
  const { user } = useContext(AuthContext);

  const isSuperadmin = user?.role === "superadmin";

  const [form, setForm] = useState({
    name: "",
    description: "",
    baseFee: "",
    telegramServerId: "",
    maxViewerDiscount: "",
    period: {
      months: 0,
      days: 0,
    },
    materialAccessPeriod: {
      months: 0,
      days: 0,
    },
    driveFolderId: "",
    contentDeliveryMode: "legacy_drive" as ContentDeliveryMode,
  });

  const [error, setError] = useState<string>("");

  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,

      [name]:
        name === "baseFee" || name === "maxViewerDiscount"
          ? value.replace(/[^0-9]/g, "")
          : value,
    }));
  };

  const handleDurationChange = (
    field: "period" | "materialAccessPeriod",
    value: {
      months: number;
      days: number;
    },
  ) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFolderSelect = (folderId: string, folderName: string) => {
    setForm((prev) => ({
      ...prev,
      driveFolderId: folderId,
    }));
  };

  const durationToDays = (d: { months: number; days: number }) =>
    d.months * 30 + d.days;

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    setError("");
    setIsSubmitting(true);

    try {
      const payload: CreateCourseRequest = {
        name: form.name.trim(),

        description: form.description.trim(),

        baseFee: Number(form.baseFee) || 0,

        telegramServerId: form.telegramServerId.trim(),

        periodMonths: durationToDays(form.period),

        maxViewerDiscount: 0,

        materialAccessPeriod: 0,

        driveFolderId: form.driveFolderId.trim(),

        contentDeliveryMode: form.contentDeliveryMode,
      };

      if (isSuperadmin) {
        payload.maxViewerDiscount = Number(form.maxViewerDiscount) || 0;

        payload.materialAccessPeriod = encodeMaterialDuration(
          form.materialAccessPeriod,
        );
      } else {
        delete (payload as any).maxViewerDiscount;

        delete (payload as any).materialAccessPeriod;
      }

      await onSubmit(payload);
    } catch (err: any) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="
                fixed inset-0 z-[1000]
                flex items-center justify-center
                bg-slate-950/35
                p-4
                backdrop-blur-[1px]
            "
    >
      <div
        className="
                    relative flex
                    max-h-[calc(100vh-32px)]
                    w-full max-w-[880px]
                    flex-col
                    overflow-hidden
                    rounded-[18px]
                    border border-slate-200
                    bg-white
                    shadow-[0_24px_80px_rgba(15,23,42,0.22)]
                "
        role="dialog"
        aria-modal="true"
        aria-labelledby="create-course-title"
      >
        {/* =================================================
                    LOADING
                ================================================= */}

        {isSubmitting && (
          <div
            className="
                            absolute inset-0 z-50
                            flex items-center justify-center
                            rounded-[18px]
                            bg-white/90
                            backdrop-blur-[2px]
                        "
          >
            <div className="flex flex-col items-center gap-3">
              <Spinner />

              <div className="text-center">
                <p className="m-0 text-[13px] font-semibold text-slate-900">
                  Creating course
                </p>

                <p className="mb-0 mt-1 text-[12px] text-slate-500">
                  Configuring course and Drive access...
                </p>
              </div>
            </div>
          </div>
        )}

        {/* =================================================
                    HEADER
                ================================================= */}

        <header
          className="
                        flex shrink-0 items-start
                        justify-between gap-4
                        border-b border-slate-200
                        px-6 py-4
                        max-sm:px-4
                    "
        >
          <div className="flex min-w-0 items-start gap-3">
            <div
              className="
                                mt-0.5 grid h-9 w-9
                                shrink-0 place-items-center
                                rounded-[10px]
                                bg-slate-100
                                text-slate-700
                            "
            >
              <CourseIcon />
            </div>

            <div className="min-w-0">
              <h2
                id="create-course-title"
                className="
                                    m-0 text-[18px]
                                    font-bold
                                    tracking-[-0.02em]
                                    text-slate-950
                                "
              >
                Create course
              </h2>

              <p
                className="
                                    mb-0 mt-1
                                    text-[12px]
                                    text-slate-500
                                "
              >
                Add the course details, access duration and connected Drive
                folder.
              </p>
            </div>
          </div>

          <button
            type="button"
            onClick={onCancel}
            disabled={isSubmitting}
            aria-label="Close"
            className="
                            grid h-8 w-8 shrink-0
                            place-items-center
                            rounded-lg
                            border-0
                            bg-transparent
                            p-0
                            text-slate-500
                            transition
                            hover:bg-slate-100
                            hover:text-slate-900
                            disabled:cursor-not-allowed
                            disabled:opacity-50
                        "
          >
            <CloseIcon />
          </button>
        </header>

        {/* =================================================
                    FORM
                ================================================= */}

        <form
          onSubmit={handleSubmit}
          className="
                        flex min-h-0 flex-1
                        flex-col overflow-hidden
                    "
        >
          {/* Scrollable content only */}

          <div
            className="
                            min-h-0 flex-1
                            overflow-y-auto
                            px-6 py-5
                            max-sm:px-4
                        "
          >
            {error && (
              <div
                className="
                                    mb-4
                                    rounded-[10px]
                                    border border-red-200
                                    bg-red-50
                                    px-3 py-2.5
                                    text-[12px]
                                    font-medium
                                    text-red-700
                                "
              >
                {error}
              </div>
            )}

            <div className="space-y-5">
              {/* =====================================
                                BASIC INFORMATION
                            ===================================== */}

              <section>
                <div className="mb-3">
                  <h3
                    className="
                                            m-0 text-[13px]
                                            font-bold
                                            text-slate-900
                                        "
                  >
                    Course details
                  </h3>

                  <p className="mb-0 mt-0.5 text-[11px] text-slate-400">
                    Basic information shown to staff and students.
                  </p>
                </div>

                <div
                  className="
                                        grid grid-cols-1
                                        gap-3
                                        md:grid-cols-2
                                    "
                >
                  <div className="md:col-span-2">
                    <label className={labelClass} htmlFor="name">
                      Course name
                      <span className="ml-1 text-red-500">*</span>
                    </label>

                    <input
                      id="name"
                      name="name"
                      type="text"
                      className={inputClass}
                      value={form.name}
                      onChange={handleChange}
                      required
                      placeholder="e.g. CEE Preparation"
                    />
                  </div>

                  <div className="md:col-span-2">
                    <label className={labelClass} htmlFor="description">
                      Description
                    </label>

                    <textarea
                      id="description"
                      name="description"
                      className={textareaClass}
                      value={form.description}
                      onChange={handleChange}
                      placeholder="Brief description of the course"
                      rows={3}
                    />
                  </div>
                </div>
              </section>

              <div className="h-px bg-slate-100" />

              <section>
                <div className="mb-3">
                  <h3 className="m-0 text-[13px] font-bold text-slate-900">
                    Content delivery
                  </h3>
                  <p className="mb-0 mt-0.5 text-[11px] text-slate-400">
                    Choose how enrolled students will receive course materials.
                  </p>
                </div>

                <label className={labelClass} htmlFor="contentDeliveryMode">
                  Delivery mode
                  <span className="ml-1 text-red-500">*</span>
                </label>
                <select
                  id="contentDeliveryMode"
                  name="contentDeliveryMode"
                  className={inputClass}
                  value={form.contentDeliveryMode}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      contentDeliveryMode: e.target.value as ContentDeliveryMode,
                    }))
                  }
                  required
                >
                  <option value="legacy_drive">Legacy Drive only</option>
                  <option value="hybrid">Hybrid — Drive and mobile app</option>
                  <option value="mobile_app">Mobile app only</option>
                </select>
                <p className="mb-0 mt-2 text-[11px] text-slate-500">
                  {form.contentDeliveryMode === "legacy_drive"
                    ? "Students use the existing Drive delivery workflow; mobile materials stay disabled."
                    : form.contentDeliveryMode === "hybrid"
                      ? "Students may use both Drive and published mobile materials."
                      : "Students use published mobile materials only; new legacy Drive access is suppressed."}
                </p>
              </section>

              <div className="h-px bg-slate-100" />

              {/* =====================================
                                COURSE SETTINGS
                            ===================================== */}

              <section>
                <div className="mb-3">
                  <h3 className="m-0 text-[13px] font-bold text-slate-900">
                    Course settings
                  </h3>

                  <p className="mb-0 mt-0.5 text-[11px] text-slate-400">
                    Pricing and course access duration.
                  </p>
                </div>

                <div
                  className="
                                        grid grid-cols-1
                                        gap-3
                                        md:grid-cols-2
                                    "
                >
                  {/* Base Fee */}

                  <div>
                    <label className={labelClass} htmlFor="baseFee">
                      Base fee
                      <span className="ml-1 text-red-500">*</span>
                    </label>

                    <div className="relative">
                      <span
                        className="
                                                    pointer-events-none
                                                    absolute left-3
                                                    top-1/2
                                                    -translate-y-1/2
                                                    text-[13px]
                                                    font-semibold
                                                    text-slate-400
                                                "
                      >
                        ₹
                      </span>

                      <input
                        id="baseFee"
                        name="baseFee"
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        className={`${inputClass} pl-7`}
                        value={form.baseFee}
                        onChange={handleChange}
                        required
                        placeholder="5000"
                        autoComplete="off"
                      />
                    </div>
                  </div>

                  {/* Superadmin Discount */}

                  {isSuperadmin && (
                    <div>
                      <label className={labelClass} htmlFor="maxViewerDiscount">
                        Max viewer discount
                        <span className="ml-1 text-red-500">*</span>
                      </label>

                      <div className="relative">
                        <span
                          className="
                                                        pointer-events-none
                                                        absolute left-3
                                                        top-1/2
                                                        -translate-y-1/2
                                                        text-[13px]
                                                        font-semibold
                                                        text-slate-400
                                                    "
                        >
                          ₹
                        </span>

                        <input
                          id="maxViewerDiscount"
                          name="maxViewerDiscount"
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          min="0"
                          className={`${inputClass} pl-7`}
                          value={form.maxViewerDiscount}
                          onChange={handleChange}
                          required
                          placeholder="20"
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  )}

                  {/* Period */}

                  <DurationInput
                    label="Course period"
                    value={form.period}
                    onChange={(value) => handleDurationChange("period", value)}
                    namePrefix="period"
                  />

                  {/* Material access */}

                  {isSuperadmin && (
                    <DurationInput
                      label="Material access period"
                      value={form.materialAccessPeriod}
                      onChange={(value) =>
                        handleDurationChange("materialAccessPeriod", value)
                      }
                      namePrefix="materialAccessPeriod"
                    />
                  )}
                </div>

                <p
                  className="
                                        mb-0 mt-2
                                        text-[10px]
                                        text-slate-400
                                    "
                >
                  Course duration uses 1 month = 30 days. Material access uses
                  1 month = 1 hour and 1 day = 1 minute.
                </p>
              </section>

              <div className="h-px bg-slate-100" />

              {/* =====================================
                                INTEGRATIONS
                            ===================================== */}

              <section>
                <div className="mb-3">
                  <h3 className="m-0 text-[13px] font-bold text-slate-900">
                    Integrations
                  </h3>

                  <p className="mb-0 mt-0.5 text-[11px] text-slate-400">
                    Link Telegram and an optional Google Drive folder.
                  </p>
                </div>

                <div className="grid grid-cols-1 gap-3">
                  <div>
                    <label className={labelClass} htmlFor="telegramServerId">
                      Telegram Server ID
                    </label>

                    <input
                      id="telegramServerId"
                      name="telegramServerId"
                      type="text"
                      className={inputClass}
                      value={form.telegramServerId}
                      onChange={handleChange}
                      placeholder="Optional"
                    />
                  </div>

                  <div className={driveSelectorStyles}>
                    <DriveFolderSelector
                      selectedFolderId={form.driveFolderId}
                      onFolderSelect={handleFolderSelect}
                    />
                  </div>
                </div>
              </section>
            </div>
          </div>

          {/* =================================================
                        FOOTER
                    ================================================= */}

          <footer
            className="
                            flex shrink-0
                            items-center
                            justify-between
                            gap-3
                            border-t
                            border-slate-200
                            bg-white
                            px-6 py-3.5
                            max-sm:flex-col-reverse
                            max-sm:px-4
                        "
          >
            <span
              className="
                                text-[11px]
                                text-slate-400
                                max-sm:hidden
                            "
            >
              Required fields are marked with *
            </span>

            <div
              className="
                                flex items-center gap-2
                                max-sm:w-full
                            "
            >
              <button
                type="button"
                onClick={onCancel}
                disabled={isSubmitting}
                className="
                                    h-10 min-w-[100px]
                                    rounded-[9px]
                                    border
                                    border-slate-200
                                    bg-white
                                    px-4
                                    text-[13px]
                                    font-semibold
                                    text-slate-700
                                    transition
                                    hover:bg-slate-50
                                    disabled:cursor-not-allowed
                                    disabled:opacity-50
                                    max-sm:flex-1
                                "
              >
                Cancel
              </button>

              <button
                type="submit"
                disabled={isSubmitting}
                className="
                                    inline-flex h-10
                                    min-w-[120px]
                                    items-center
                                    justify-center
                                    gap-2
                                    rounded-[9px]
                                    border-0
                                    bg-[#0d162a]
                                    px-4
                                    text-[13px]
                                    font-semibold
                                    text-white
                                    transition
                                    hover:bg-[#172239]
                                    disabled:cursor-not-allowed
                                    disabled:opacity-60
                                    max-sm:flex-1
                                "
              >
                {isSubmitting && (
                  <span
                    className="
                                            inline-block h-4
                                            w-4 animate-spin
                                            rounded-full
                                            border-2
                                            border-white/30
                                            border-t-white
                                        "
                  />
                )}

                {isSubmitting ? "Creating..." : "Create course"}
              </button>
            </div>
          </footer>
        </form>
      </div>
    </div>
  );
}
